export const globalStyles = {
  colors: {
    "gray-50": "#F7FAFC",
    "gray-100": "#EDF2F7",
    "gray-200": "#E2E8F0",
    "gray-300": "#CBD5E0",
    "gray-400": "#A0AEC0",
    "gray-500": "#718096",
    "gray-600": "#4A5568",
    "gray-700": "#041E42",
    "gray-800": "#1A202C",
    "gray-900": "#171923",

    "red-500": "#F00014",

    // semantic

    primary: {
      50: "#FFF2F1",
      100: "#FFE2E0",
      200: "#FFC6C3",
      300: "#FF908B",
      400: "#F66A65",
      500: "#E5554F",
      600: "#CB362F",
      700: "#962B26",
      800: "#77211E",
      900: "#630F0B",
    },

    secondary: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#041E42",
      800: "#1A202C",
      900: "#171923",
    },

    success: {
      50: "#F0FFF4",
      100: "#C6F6D5",
      200: "#9AE6B4",
      300: "#68D391",
      400: "#48BB78",
      500: "#38A169",
      600: "#25855A",
      700: "#276749",
      800: "#22543D",
      900: "#1C4532",
    },

    invalid: {
      50: "#FFFAF0",
      100: "#FEEBCB",
      200: "#FBD38D",
      300: "#FFB875",
      400: "#FFA856",
      500: "#FF9632",
      600: "#C7701E",
      700: "#9C4221",
      800: "#7B341E",
      900: "#652B19",
    },

    brand: "#E5554F",
    darkBrand: "#041E42",
    error: "#FF9632",
  },
  styles: {},
};
